import { isFeatureEnabled, isAnyFeatureEnabled } from "shared/featureflags/helperFunctions"
import { bulkUploadIsAvailable } from "shared/search/helperFunctions"
import { getBillLanguageFilterOptions } from "shared/selects/helperFunctions"
import { usRegions } from "shared/imports/regionConstants"
import * as constants from "shared/imports/sharedConstants"

import {
    AssignmentFilterGroup,
    InvisibleDefaultFilterGroup,
    FromTrackingBoardInvisibleFilterGroup,
} from "shared/search/containers/FilterGroup/FilterGroups"

import {
    OfficialAssumedOfficeFilterGroup,
    OfficialBiographyFilterGroup,
    OfficialCampaignFilterGroup,
    OfficialCommitteeFilterGroup,
    OfficialCustomEventFilterGroup,
    OfficialCustomFilterGroup,
    OfficialDataMaintenanceFilterGroup,
    OfficialExecutiveRoleFilterGroup,
    OfficialLegislativeActionsFilterGroup,
    OfficialLegislativeRoleFilterGroup,
    OfficialPartyFilterGroup,
    PersonProjectFilterGroup,
    OfficialTypeFilterGroup,
    OfficialsCampaignFinanceFilterGroup,
    PersonDocumentFilterGroup,
    PersonInteractionFilterGroup,
    PersonListFilterGroup,
    PersonOutboxFilterGroup,
    PersonRepresentingFilterGroup,
    PersonRepresentsInternationalRegionFilterGroup,
    PersonRepresentsRegionFilterGroup,
    PersonStakeholderFilterGroup,
    OfficialPACTransactionsFilterGroup,
    PacClassicOfficialPACActivityFilterGroup,
} from "shared/search/containers/FilterGroup/OfficialFilterGroups"

import {
    BillCustomFilterGroup,
    BillDateFilterGroup,
    BillLanguageFilterGroup,
    BillTypeFilterGroup,
    BillStatusFilterGroup,
    BillTitleFilterGroup,
    BillTermFilterGroup,
    BillCommitteeFilterGroup,
    BillCompanionFilterGroup,
    BillSponsorFilterGroup,
    BillListFilterGroup,
    BillStanceFilterGroup,
    BillPriorityFilterGroup,
    BillSupportedRegionFilterGroup,
    BillRelatedFilterGroup,
    BillInvisibleFilterGroup,
    BillDataMaintenanceFilterGroup,
    BillProjectFilterGroup,
    BillTrackingDashboardFilterGroup,
    BillReviewFilterGroup,
    // eu
    BillSourceFilterGroup,
    // order_by
    BillOrderByFilterGroup,
} from "shared/search/containers/FilterGroup/BillFilterGroups"

import {
    DocumentTypeCommsOnlyFilterGroup,
    DocumentTypeFilterGroup,
    DocumentStanceFilterGroup,
    DocumentSourceFilterGroup,
    DocumentDateFilterGroup,
    DocumentMentionCommsOnlyFilterGroup,
    DocumentMentionFilterGroup,
    DocumentRegionFilterGroup,
    DocumentTrackingDashboardFilterGroup,
    DocumentListFilterGroup,
    DocumentInvisibleFilterGroup,
    DocumentProjectFilterGroup,
    DocumentReviewFilterGroup,
    DocumentOrderByFilterGroup,
} from "shared/search/containers/FilterGroup/DocumentFilterGroups"

import {
    EventChamberFilterGroup,
    EventDateFilterGroup,
    EventTypeFilterGroup,
    EventMentionFilterGroup,
    // for Committee profile
    EventProjectFilterGroup,
    EventRegionFilterGroup,
    EventOrderByFilterGroup,
} from "shared/search/containers/FilterGroup/EventFilterGroups"

import {
    StafferTypeFilterGroup,
    StafferCustomFilterGroup,
    StafferListFilterGroup,
    StafferDataMaintenanceFilterGroup,
    StafferProjectFilterGroup,
    StafferCustomEventFilterGroup,
    StafferRepresentsRegionFilterGroup,
} from "shared/search/containers/FilterGroup/StafferFilterGroups"

import {
    SupporterCustomFilterGroup,
    SupporterOrganizationFilterGroup,
    SupporterSearchFilterGroup,
    SupporterGeographyFilterGroup,
    SupporterListFilterGroup,
    SupporterAssignmentFilterGroup,
    SupporterLegislatorsFilterGroup,
    SupporterCampaignFilterGroup,
    SupporterPACFilterGroup,
    SupporterDateFilterGroup,
    SupporterOutboxFilterGroup,
    SupporterDataMaintenanceFilterGroup,
    SupporterProjectFilterGroup,
    SupporterTextFilterGroup,
    // for custom events
    SupporterCustomEventFilterGroup,
    SupporterStakeholderFilterGroup,
    SupporterOrderByFilterGroup,
    SupporterCampaignFinanceFilterGroup,
} from "shared/search/containers/FilterGroup/SupporterFilterGroups"

import {
    NoteCreatedDateFilterGroup,
    NoteCustomFilterGroup,
    NoteDonationFilterGroup,
    NoteDurationFilterGroup,
    NoteInvisibleFilterGroup,
    NoteInvolvingFilterGroup,
    NoteListFilterGroup,
    NoteMentionFilterGroup,
    NoteOrderByFilterGroup,
    NoteProjectFilterGroup,
    NoteRegionFilterGroup,
    NoteSourceFilterGroup,
    NoteStartDateFilterGroup,
    NoteTypeFilterGroup,
} from "shared/search/containers/FilterGroup/NoteFilterGroups"

import {
    PublicOrganizationTypeFilterGroup,
    PublicOrganizationParentFilterGroup,
    PublicOrganizationCustomFilterGroup,
    PublicOrganizationRegionFilterGroup,
    PublicOrganizationSocialMediaFilterGroup,
    PublicOrganizationDocumentFilterGroup,
    PublicOrganizationListFilterGroup,
    PublicOrganizationDataMaintenanceFilterGroup,
    PublicOrganizationProjectFilterGroup,
    PublicOrganizationPacFilterGroup,
    PublicOrganizationOutletFilterGroup,
    PublicOrganizationOrderByFilterGroup,
} from "shared/search/containers/FilterGroup/PublicOrganizationFilterGroups"

import {
    GrassrootsActionCampaignFilterGroup,
    GrassrootsActionDateFilterGroup,
    GrassrootsActionSourceFilterGroup,
    GrassrootsActionTypeFilterGroup,
    GrassrootsActionSocialMediaTypeFilterGroup,
    GrassrootsActionInvolvingFilterGroup,
    GrassrootsListFilterGroup,
    GrassrootsActionPacFilterGroup,
    GrassrootsActionSubmittingOrganizationFilterGroup,
    GrassrootsCustomActionFieldsFilterGroup,
} from "shared/search/containers/FilterGroup/GrassrootsActionFilterGroups"

import {
    ElectionTypeFilterGroup,
    ElectionCycleFilterGroup,
    ElectionAmountFilterGroup,
} from "shared/search/containers/FilterGroup/ElectionFilterGroups"

import {
    PoliticalCommitteeOfficialsFilterGroup,
    PoliticalCommitteeCandidateFilterGroup,
    PoliticalCommitteeFecPartyTypeFilterGroup,
    PoliticalCommitteeStateRegionFilterGroup,
    PoliticalCommitteeTransactionFilterGroup,
    PoliticalCommitteeTypeFilterGroup,
    PoliticalCommitteeCampaignFinanceFilterGroup,
    PoliticalCommitteeDetailsFilterGroup,
} from "shared/search/containers/FilterGroup/PoliticalCommitteeFilterGroups"

import {
    TransactionTypeFilterGroup,
    TransactionContributionTypeFilterGroup,
    TransactionAmountFilterGroup,
    TransactionSupporterFilterGroup,
    TransactionPublicOrganizationFilterGroup,
    TransactionPoliticalCommitteeFilterGroup,
    TransactionOfficialFilterGroup,
    TransactionElectionFilterGroup,
    TransactionDetailsFilterGroup,
} from "shared/search/containers/FilterGroup/TransactionFilterGroups"
import { isGrassrootsPersona } from "shared/grassroots/helperFunctions"
import { hasAnyPermission } from "shared/imports/permissionFunctions"
import { canViewGrassrootsActionPacData } from "shared/pac/permissionHelpers"

const pacFilterGroups = {
    filterGroups: {
        OfficialFilterSet: [
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [OfficialPACTransactionsFilterGroup]
                : []),
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.pac_hybrid])
                ? [PacClassicOfficialPACActivityFilterGroup]
                : []),
            OfficialTypeFilterGroup,
            OfficialPartyFilterGroup,
            ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                ? [PersonRepresentsRegionFilterGroup]
                : [PersonRepresentsInternationalRegionFilterGroup]),
            OfficialCommitteeFilterGroup,
            OfficialCampaignFilterGroup,
            OfficialsCampaignFinanceFilterGroup,
            PersonRepresentingFilterGroup,
            PersonOutboxFilterGroup,
            PersonProjectFilterGroup,
            OfficialCustomFilterGroup,
            OfficialAssumedOfficeFilterGroup,
            OfficialLegislativeActionsFilterGroup,
            OfficialLegislativeRoleFilterGroup,
            OfficialExecutiveRoleFilterGroup,
            PersonListFilterGroup,
            PersonInteractionFilterGroup,
            OfficialCustomEventFilterGroup,
            PersonStakeholderFilterGroup,
            AssignmentFilterGroup,
            OfficialBiographyFilterGroup,
            PersonDocumentFilterGroup,
            InvisibleDefaultFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                ? [OfficialDataMaintenanceFilterGroup]
                : []),
        ],
        // // TODO: The below isGrassrootsPersona() = true filters haven't been reordered
        // for User Personas. TBD per Product team if there should be changes.
        SupporterFilterSet: isGrassrootsPersona()
            ? [
                  SupporterCampaignFilterGroup,
                  SupporterOutboxFilterGroup,
                  SupporterTextFilterGroup,
                  SupporterCustomFilterGroup,
                  SupporterSearchFilterGroup,
                  SupporterGeographyFilterGroup,
                  SupporterLegislatorsFilterGroup,
                  SupporterOrderByFilterGroup,
                  SupporterCustomEventFilterGroup,
                  SupporterDateFilterGroup,
                  SupporterOrganizationFilterGroup,
                  SupporterListFilterGroup,
                  SupporterDataMaintenanceFilterGroup,
                  InvisibleDefaultFilterGroup,
                  SupporterStakeholderFilterGroup,
                  SupporterProjectFilterGroup,
                  PersonInteractionFilterGroup,
                  SupporterAssignmentFilterGroup,
                  SupporterCampaignFinanceFilterGroup,
                  ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
              ]
            : [
                  ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  SupporterSearchFilterGroup,
                  SupporterOrganizationFilterGroup,
                  SupporterCustomFilterGroup,
                  SupporterCampaignFilterGroup,
                  SupporterCampaignFinanceFilterGroup,
                  SupporterOutboxFilterGroup,
                  SupporterGeographyFilterGroup,
                  SupporterProjectFilterGroup,
                  SupporterListFilterGroup,
                  SupporterLegislatorsFilterGroup,
                  PersonInteractionFilterGroup,
                  SupporterCustomEventFilterGroup,
                  SupporterStakeholderFilterGroup,
                  SupporterTextFilterGroup,
                  SupporterAssignmentFilterGroup,
                  SupporterDateFilterGroup,
                  InvisibleDefaultFilterGroup,
                  SupporterOrderByFilterGroup,
                  SupporterDataMaintenanceFilterGroup,
              ],
        NoteFilterSet: [
            NoteTypeFilterGroup,
            NoteSourceFilterGroup,
            NoteInvolvingFilterGroup,
            NoteStartDateFilterGroup,
            NoteCreatedDateFilterGroup,
            NoteProjectFilterGroup,
            ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
            NoteMentionFilterGroup,
            NoteCustomFilterGroup,
            NoteListFilterGroup,
            NoteDurationFilterGroup,
            NoteDonationFilterGroup,
            NoteInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        GrassrootsActionFilterSet: [
            ...(canViewGrassrootsActionPacData() ? [GrassrootsActionPacFilterGroup] : []),
            GrassrootsActionTypeFilterGroup,
            GrassrootsActionDateFilterGroup,
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.action_center_campaigns])
                ? [GrassrootsActionCampaignFilterGroup]
                : []),
            ...(isFeatureEnabled("ff_ngg_interactive_campaign_profile")
                ? [GrassrootsCustomActionFieldsFilterGroup]
                : []),
            GrassrootsActionInvolvingFilterGroup,
            BillProjectFilterGroup,
            NoteRegionFilterGroup,
            GrassrootsListFilterGroup,
            GrassrootsActionSubmittingOrganizationFilterGroup,
            GrassrootsActionSourceFilterGroup,
            GrassrootsActionSocialMediaTypeFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        PublicOrganizationFilterSet: [
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [PublicOrganizationPacFilterGroup]
                : []),
            PublicOrganizationTypeFilterGroup,
            PublicOrganizationCustomFilterGroup,
            PublicOrganizationParentFilterGroup,
            PublicOrganizationRegionFilterGroup,
            PublicOrganizationProjectFilterGroup,
            PublicOrganizationListFilterGroup,
            PublicOrganizationOutletFilterGroup,
            ...(Userdata.Permissions.is_comms_only
                ? [PublicOrganizationSocialMediaFilterGroup]
                : [PublicOrganizationDocumentFilterGroup]),
            AssignmentFilterGroup,
            InvisibleDefaultFilterGroup,
            PublicOrganizationOrderByFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                ? [PublicOrganizationDataMaintenanceFilterGroup]
                : []),
        ],
        ElectionFilterSet: [ElectionAmountFilterGroup, ElectionCycleFilterGroup, ElectionTypeFilterGroup],
        PoliticalCommitteeFilterSet: [
            PoliticalCommitteeTransactionFilterGroup,
            PoliticalCommitteeTypeFilterGroup,
            PoliticalCommitteeCandidateFilterGroup,
            PoliticalCommitteeOfficialsFilterGroup,
            PoliticalCommitteeStateRegionFilterGroup,
            PoliticalCommitteeFecPartyTypeFilterGroup,
            PoliticalCommitteeCampaignFinanceFilterGroup,
            PoliticalCommitteeDetailsFilterGroup,
        ],
        TransactionFilterSet: [
            ...(!isFeatureEnabled("ff_pac_permissions_one") ||
            Userdata.can_view_pac_receipts ||
            Userdata.can_view_pac_disbursements
                ? [TransactionTypeFilterGroup]
                : []),
            TransactionAmountFilterGroup,
            TransactionContributionTypeFilterGroup,
            TransactionSupporterFilterGroup,
            TransactionPoliticalCommitteeFilterGroup,
            TransactionOfficialFilterGroup,
            TransactionPublicOrganizationFilterGroup,
            TransactionElectionFilterGroup,
            TransactionDetailsFilterGroup,
            // TODO from shared/search/containers/FilterSet/FilterSets.js:
            // show only when client has multiple pacs
            // TransactionLedgerSettingsFilterGroup,
        ],
    },
    seeMoreFilterGroups: {},
}

const languageFilterEnabled = getBillLanguageFilterOptions().length > 1

const grassrootsFilterGroups = {
    filterGroups: {
        OfficialFilterSet: [
            OfficialTypeFilterGroup,
            ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                ? [PersonRepresentsRegionFilterGroup]
                : [PersonRepresentsInternationalRegionFilterGroup]),
            OfficialCustomFilterGroup,
            OfficialCampaignFilterGroup,
            OfficialsCampaignFinanceFilterGroup,
            OfficialLegislativeRoleFilterGroup,
            OfficialExecutiveRoleFilterGroup,
            OfficialPartyFilterGroup,
            OfficialCommitteeFilterGroup,
            PersonListFilterGroup,
            OfficialLegislativeActionsFilterGroup,
            OfficialAssumedOfficeFilterGroup,
            PersonOutboxFilterGroup,
            PersonRepresentingFilterGroup,
            PersonStakeholderFilterGroup,
            PersonProjectFilterGroup,
            AssignmentFilterGroup,
            OfficialBiographyFilterGroup,
            InvisibleDefaultFilterGroup,
        ],
        BillFilterSet: [
            BillDateFilterGroup,
            ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
            BillSupportedRegionFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
            BillProjectFilterGroup,
            BillStanceFilterGroup,
            BillStatusFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
            BillCustomFilterGroup,
            BillPriorityFilterGroup,
            BillListFilterGroup,
            BillSponsorFilterGroup,
            AssignmentFilterGroup,
            BillTrackingDashboardFilterGroup,
            BillTitleFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
            BillReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
            ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
            ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
            ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                ? [BillDataMaintenanceFilterGroup]
                : []),
            BillInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            BillOrderByFilterGroup,
        ],
        DocumentFilterSet: [
            DocumentSourceFilterGroup,
            DocumentDateFilterGroup,
            DocumentRegionFilterGroup,
            Userdata.Permissions.is_comms_only ? DocumentMentionCommsOnlyFilterGroup : DocumentMentionFilterGroup,
            DocumentProjectFilterGroup,
            DocumentListFilterGroup,
            DocumentTrackingDashboardFilterGroup,
            DocumentReviewFilterGroup,
            FromTrackingBoardInvisibleFilterGroup,
            DocumentStanceFilterGroup,
            Userdata.Permissions.is_comms_only ? DocumentTypeCommsOnlyFilterGroup : DocumentTypeFilterGroup,
            DocumentInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            DocumentOrderByFilterGroup,
        ],
        StafferFilterSet: [
            StafferCustomFilterGroup,
            StafferTypeFilterGroup,
            StafferRepresentsRegionFilterGroup,
            PersonRepresentsInternationalRegionFilterGroup,
            PersonStakeholderFilterGroup,
            StafferProjectFilterGroup,
            StafferListFilterGroup,
            AssignmentFilterGroup,
            PersonInteractionFilterGroup,
            PersonOutboxFilterGroup,
            StafferCustomEventFilterGroup,
            InvisibleDefaultFilterGroup,
        ],
        NoteFilterSet: [
            NoteTypeFilterGroup,
            NoteInvolvingFilterGroup,
            NoteStartDateFilterGroup,
            NoteCreatedDateFilterGroup,
            NoteCustomFilterGroup,
            NoteSourceFilterGroup,
            ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
            NoteMentionFilterGroup,
            NoteProjectFilterGroup,
            NoteListFilterGroup,
            NoteDurationFilterGroup,
            NoteInvisibleFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        GrassrootsActionFilterSet: [
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.action_center_campaigns])
                ? [GrassrootsActionCampaignFilterGroup]
                : []),
            ...(isFeatureEnabled("ff_ngg_interactive_campaign_profile")
                ? [GrassrootsCustomActionFieldsFilterGroup]
                : []),
            GrassrootsActionTypeFilterGroup,
            GrassrootsActionDateFilterGroup,
            GrassrootsActionSourceFilterGroup,
            GrassrootsActionInvolvingFilterGroup,
            NoteRegionFilterGroup,
            GrassrootsListFilterGroup,
            GrassrootsActionSocialMediaTypeFilterGroup,
            BillProjectFilterGroup,
            InvisibleDefaultFilterGroup,
            NoteOrderByFilterGroup,
        ],
        EventFilterSet: [
            EventTypeFilterGroup,
            EventDateFilterGroup,
            EventRegionFilterGroup,
            EventChamberFilterGroup,
            EventMentionFilterGroup,
            EventProjectFilterGroup,
            EventOrderByFilterGroup,
            InvisibleDefaultFilterGroup,
        ],
        PublicOrganizationFilterSet: [
            PublicOrganizationCustomFilterGroup,
            PublicOrganizationTypeFilterGroup,
            PublicOrganizationParentFilterGroup,
            Userdata.Permissions.is_comms_only ? DocumentTypeCommsOnlyFilterGroup : DocumentTypeFilterGroup,
            PublicOrganizationRegionFilterGroup,
            PublicOrganizationProjectFilterGroup,
            AssignmentFilterGroup,
            PublicOrganizationListFilterGroup,
            InvisibleDefaultFilterGroup,
            PublicOrganizationOrderByFilterGroup,
        ],
        TransactionFilterSet: [
            TransactionTypeFilterGroup,
            TransactionAmountFilterGroup,
            TransactionContributionTypeFilterGroup,
            TransactionSupporterFilterGroup,
            TransactionPoliticalCommitteeFilterGroup,
            TransactionOfficialFilterGroup,
            TransactionPublicOrganizationFilterGroup,
            TransactionElectionFilterGroup,
            TransactionDetailsFilterGroup,
        ],
    },
    seeMoreFilterGroups: {
        OfficialFilterSet: [
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                ? [OfficialDataMaintenanceFilterGroup]
                : []),
            PersonDocumentFilterGroup,
            OfficialCustomEventFilterGroup,
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [OfficialPACTransactionsFilterGroup]
                : []),
        ],
        StafferFilterSet: [
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                ? [StafferDataMaintenanceFilterGroup]
                : []),
        ],
        NoteFilterSet: [NoteDonationFilterGroup],
        GrassrootsActionFilterSet: [
            ...(canViewGrassrootsActionPacData() ? [GrassrootsActionPacFilterGroup] : []),
            GrassrootsActionSubmittingOrganizationFilterGroup,
        ],
        PublicOrganizationFilterSet: [
            PublicOrganizationOutletFilterGroup,
            ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                ? [PublicOrganizationDataMaintenanceFilterGroup]
                : []),
            ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                ? [PublicOrganizationPacFilterGroup]
                : []),
        ],
    },
}

export const UserPersonaConstant = {
    // Dictionary to define "personified" search filters, to change search filter options
    // based on UserPersona values for the Persona Optimization Project (POP)/ff_personas.
    // The original FilterSets are in shared/search/containers/FilterSet/FilterSets.js
    [DjangIO.app.userdata.types.UserPersona.legislative_admin.value]: {
        filterGroups: {
            OfficialFilterSet: [
                OfficialCustomFilterGroup,
                OfficialTypeFilterGroup,
                OfficialLegislativeRoleFilterGroup,
                OfficialExecutiveRoleFilterGroup,
                OfficialPartyFilterGroup,
                OfficialCommitteeFilterGroup,
                OfficialLegislativeActionsFilterGroup,
                OfficialAssumedOfficeFilterGroup,
                ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                    ? [PersonRepresentsRegionFilterGroup]
                    : [PersonRepresentsInternationalRegionFilterGroup]),

                PersonRepresentingFilterGroup,
                PersonStakeholderFilterGroup,
                PersonProjectFilterGroup,
                PersonListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                OfficialCampaignFilterGroup,
                OfficialsCampaignFinanceFilterGroup,
                OfficialBiographyFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            BillFilterSet: [
                BillCustomFilterGroup,
                BillDateFilterGroup,
                ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
                ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
                BillStatusFilterGroup,
                BillSupportedRegionFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
                BillStanceFilterGroup,
                BillPriorityFilterGroup,
                BillProjectFilterGroup,
                BillListFilterGroup,
                AssignmentFilterGroup,
                BillTrackingDashboardFilterGroup,
                BillSponsorFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
                BillTitleFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
                BillInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                BillOrderByFilterGroup,
                BillReviewFilterGroup,
                FromTrackingBoardInvisibleFilterGroup,
            ],
            StafferFilterSet: [
                StafferCustomFilterGroup,
                StafferTypeFilterGroup,
                StafferRepresentsRegionFilterGroup,
                PersonRepresentsInternationalRegionFilterGroup,
                PersonStakeholderFilterGroup,
                StafferProjectFilterGroup,
                StafferListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? [
                      // TODO: The below isGrassrootsPersona() = true filters haven't been reordered
                      // for ff_personas. TBD per Product team if there should be changes.
                      SupporterCampaignFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterTextFilterGroup,
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCustomEventFilterGroup,
                      SupporterDateFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterListFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  ]
                : [
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      SupporterListFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterDateFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterCampaignFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                  ],
            NoteFilterSet: [
                NoteCustomFilterGroup,
                NoteTypeFilterGroup,
                NoteSourceFilterGroup,
                NoteInvolvingFilterGroup,
                NoteStartDateFilterGroup,
                NoteCreatedDateFilterGroup,
                ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
                NoteMentionFilterGroup,
                NoteProjectFilterGroup,
                NoteListFilterGroup,
                NoteDurationFilterGroup,
                NoteInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                NoteOrderByFilterGroup,
            ],
            PublicOrganizationFilterSet: [
                PublicOrganizationCustomFilterGroup,
                PublicOrganizationTypeFilterGroup,
                PublicOrganizationParentFilterGroup,
                ...(Userdata.Permissions.is_comms_only
                    ? [PublicOrganizationSocialMediaFilterGroup]
                    : [PublicOrganizationDocumentFilterGroup]),
                PublicOrganizationRegionFilterGroup,
                PublicOrganizationProjectFilterGroup,
                AssignmentFilterGroup,
                PublicOrganizationListFilterGroup,
                InvisibleDefaultFilterGroup,
                PublicOrganizationOrderByFilterGroup,
            ],
        },
        seeMoreFilterGroups: {
            OfficialFilterSet: [
                OfficialCustomEventFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [OfficialPACTransactionsFilterGroup]
                    : []),
                PersonDocumentFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                    ? [OfficialDataMaintenanceFilterGroup]
                    : []),
            ],
            BillFilterSet: [
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                    ? [BillDataMaintenanceFilterGroup]
                    : []),
            ],
            StafferFilterSet: [
                StafferCustomEventFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                    ? [StafferDataMaintenanceFilterGroup]
                    : []),
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? []
                : [
                      SupporterTextFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                      SupporterCustomEventFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                  ],
            NoteFilterSet: [NoteDonationFilterGroup],
            PublicOrganizationFilterSet: [
                PublicOrganizationOutletFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [PublicOrganizationPacFilterGroup]
                    : []),
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                    ? [PublicOrganizationDataMaintenanceFilterGroup]
                    : []),
            ],
        },
    },
    [DjangIO.app.userdata.types.UserPersona.legislative_tracker.value]: {
        filterGroups: {
            OfficialFilterSet: [
                OfficialCustomFilterGroup,
                OfficialTypeFilterGroup,
                OfficialLegislativeRoleFilterGroup,
                OfficialExecutiveRoleFilterGroup,
                OfficialPartyFilterGroup,
                OfficialCommitteeFilterGroup,
                OfficialLegislativeActionsFilterGroup,
                OfficialAssumedOfficeFilterGroup,
                ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                    ? [PersonRepresentsRegionFilterGroup]
                    : [PersonRepresentsInternationalRegionFilterGroup]),
                PersonRepresentingFilterGroup,
                PersonStakeholderFilterGroup,
                PersonProjectFilterGroup,
                PersonListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                OfficialCampaignFilterGroup,
                OfficialsCampaignFinanceFilterGroup,
                OfficialBiographyFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            BillFilterSet: [
                BillCustomFilterGroup,
                BillDateFilterGroup,
                ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
                ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
                BillStatusFilterGroup,
                BillSupportedRegionFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
                BillStanceFilterGroup,
                BillPriorityFilterGroup,
                BillProjectFilterGroup,
                BillListFilterGroup,
                AssignmentFilterGroup,
                BillTrackingDashboardFilterGroup,
                BillSponsorFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
                BillTitleFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
                BillInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                BillOrderByFilterGroup,
                BillReviewFilterGroup,
                FromTrackingBoardInvisibleFilterGroup,
            ],
            StafferFilterSet: [
                StafferCustomFilterGroup,
                StafferTypeFilterGroup,
                StafferRepresentsRegionFilterGroup,
                PersonRepresentsInternationalRegionFilterGroup,
                PersonStakeholderFilterGroup,
                StafferProjectFilterGroup,
                StafferListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? [
                      // TODO: The below isGrassrootsPersona() = true filters haven't been reordered
                      // for ff_personas. TBD per Product team if there should be changes.
                      SupporterCampaignFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterTextFilterGroup,
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCustomEventFilterGroup,
                      SupporterDateFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterListFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  ]
                : [
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      SupporterListFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterDateFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterCampaignFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                  ],
            NoteFilterSet: [
                NoteCustomFilterGroup,
                NoteTypeFilterGroup,
                NoteSourceFilterGroup,
                NoteInvolvingFilterGroup,
                NoteStartDateFilterGroup,
                NoteCreatedDateFilterGroup,
                ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
                NoteMentionFilterGroup,
                NoteProjectFilterGroup,
                NoteListFilterGroup,
                NoteDurationFilterGroup,
                NoteInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                NoteOrderByFilterGroup,
            ],
            PublicOrganizationFilterSet: [
                PublicOrganizationCustomFilterGroup,
                PublicOrganizationTypeFilterGroup,
                PublicOrganizationParentFilterGroup,
                ...(Userdata.Permissions.is_comms_only
                    ? [PublicOrganizationSocialMediaFilterGroup]
                    : [PublicOrganizationDocumentFilterGroup]),
                PublicOrganizationRegionFilterGroup,
                PublicOrganizationProjectFilterGroup,
                AssignmentFilterGroup,
                PublicOrganizationListFilterGroup,
                InvisibleDefaultFilterGroup,
                PublicOrganizationOrderByFilterGroup,
            ],
        },
        seeMoreFilterGroups: {
            OfficialFilterSet: [
                OfficialCustomEventFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [OfficialPACTransactionsFilterGroup]
                    : []),
                PersonDocumentFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                    ? [OfficialDataMaintenanceFilterGroup]
                    : []),
            ],
            BillFilterSet: [
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                    ? [BillDataMaintenanceFilterGroup]
                    : []),
            ],
            StafferFilterSet: [
                StafferCustomEventFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                    ? [StafferDataMaintenanceFilterGroup]
                    : []),
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? []
                : [
                      SupporterTextFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                      SupporterCustomEventFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                  ],
            NoteFilterSet: [NoteDonationFilterGroup],
            PublicOrganizationFilterSet: [
                PublicOrganizationOutletFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [PublicOrganizationPacFilterGroup]
                    : []),
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                    ? [PublicOrganizationDataMaintenanceFilterGroup]
                    : []),
            ],
        },
    },
    [DjangIO.app.userdata.types.UserPersona.legislative_relationship_manager.value]: {
        filterGroups: {
            OfficialFilterSet: [
                OfficialCustomFilterGroup,
                OfficialTypeFilterGroup,
                OfficialLegislativeRoleFilterGroup,
                OfficialExecutiveRoleFilterGroup,
                OfficialPartyFilterGroup,
                OfficialCommitteeFilterGroup,
                OfficialLegislativeActionsFilterGroup,
                OfficialAssumedOfficeFilterGroup,
                ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                    ? [PersonRepresentsRegionFilterGroup]
                    : [PersonRepresentsInternationalRegionFilterGroup]),
                PersonRepresentingFilterGroup,
                PersonStakeholderFilterGroup,
                PersonProjectFilterGroup,
                PersonListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                OfficialCampaignFilterGroup,
                OfficialsCampaignFinanceFilterGroup,
                OfficialCustomEventFilterGroup,
                OfficialBiographyFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            BillFilterSet: [
                BillCustomFilterGroup,
                BillDateFilterGroup,
                ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
                ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
                BillStatusFilterGroup,
                BillSupportedRegionFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
                BillStanceFilterGroup,
                BillPriorityFilterGroup,
                BillProjectFilterGroup,
                BillListFilterGroup,
                AssignmentFilterGroup,
                BillTrackingDashboardFilterGroup,
                BillSponsorFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
                BillTitleFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
                BillInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                BillOrderByFilterGroup,
                BillReviewFilterGroup,
                FromTrackingBoardInvisibleFilterGroup,
            ],
            StafferFilterSet: [
                StafferCustomFilterGroup,
                StafferTypeFilterGroup,
                StafferRepresentsRegionFilterGroup,
                PersonRepresentsInternationalRegionFilterGroup,
                PersonStakeholderFilterGroup,
                StafferProjectFilterGroup,
                StafferListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                InvisibleDefaultFilterGroup,
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? [
                      // TODO: The below isGrassrootsPersona() = true filters haven't been reordered
                      // for ff_personas. TBD per Product team if there should be changes.
                      SupporterCampaignFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterTextFilterGroup,
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCustomEventFilterGroup,
                      SupporterDateFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterListFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  ]
                : [
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      SupporterListFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterDateFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterCampaignFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                  ],
            NoteFilterSet: [
                NoteCustomFilterGroup,
                NoteTypeFilterGroup,
                NoteSourceFilterGroup,
                NoteInvolvingFilterGroup,
                NoteStartDateFilterGroup,
                NoteCreatedDateFilterGroup,
                ...(constants.GOOGLE_ACCOUNT_IDS.includes(Userdata.organization_id) ? [] : [NoteRegionFilterGroup]),
                NoteMentionFilterGroup,
                NoteProjectFilterGroup,
                NoteListFilterGroup,
                NoteDurationFilterGroup,
                NoteInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                NoteOrderByFilterGroup,
            ],
            PublicOrganizationFilterSet: [
                PublicOrganizationCustomFilterGroup,
                PublicOrganizationTypeFilterGroup,
                PublicOrganizationParentFilterGroup,
                ...(Userdata.Permissions.is_comms_only
                    ? [PublicOrganizationSocialMediaFilterGroup]
                    : [PublicOrganizationDocumentFilterGroup]),
                PublicOrganizationRegionFilterGroup,
                PublicOrganizationProjectFilterGroup,
                AssignmentFilterGroup,
                PublicOrganizationListFilterGroup,
                InvisibleDefaultFilterGroup,
                PublicOrganizationOrderByFilterGroup,
            ],
        },
        seeMoreFilterGroups: {
            OfficialFilterSet: [
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [OfficialPACTransactionsFilterGroup]
                    : []),
                PersonDocumentFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                    ? [OfficialDataMaintenanceFilterGroup]
                    : []),
            ],
            BillFilterSet: [
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                    ? [BillDataMaintenanceFilterGroup]
                    : []),
            ],
            StafferFilterSet: [
                StafferCustomEventFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.staffer)
                    ? [StafferDataMaintenanceFilterGroup]
                    : []),
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? []
                : [
                      SupporterTextFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                      SupporterCustomEventFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                  ],
            NoteFilterSet: [NoteDonationFilterGroup],
            PublicOrganizationFilterSet: [
                PublicOrganizationOutletFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [PublicOrganizationPacFilterGroup]
                    : []),
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                    ? [PublicOrganizationDataMaintenanceFilterGroup]
                    : []),
            ],
        },
    },
    [DjangIO.app.userdata.types.UserPersona.stakeholder_admin.value]: {
        filterGroups: {
            OfficialFilterSet: [
                OfficialCustomFilterGroup,
                OfficialTypeFilterGroup,
                OfficialLegislativeRoleFilterGroup,
                OfficialExecutiveRoleFilterGroup,
                OfficialPartyFilterGroup,
                OfficialCommitteeFilterGroup,
                OfficialLegislativeActionsFilterGroup,
                OfficialAssumedOfficeFilterGroup,
                ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                    ? [PersonRepresentsRegionFilterGroup]
                    : [PersonRepresentsInternationalRegionFilterGroup]),
                PersonRepresentingFilterGroup,
                PersonStakeholderFilterGroup,
                PersonProjectFilterGroup,
                PersonListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                OfficialCampaignFilterGroup,
                OfficialsCampaignFinanceFilterGroup,
                OfficialCustomEventFilterGroup,
                OfficialBiographyFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                    ? [OfficialDataMaintenanceFilterGroup]
                    : []),
                InvisibleDefaultFilterGroup,
            ],
            BillFilterSet: [
                BillCustomFilterGroup,
                BillDateFilterGroup,
                ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
                ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
                BillStatusFilterGroup,
                BillSupportedRegionFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
                BillStanceFilterGroup,
                BillPriorityFilterGroup,
                BillProjectFilterGroup,
                BillListFilterGroup,
                AssignmentFilterGroup,
                BillTrackingDashboardFilterGroup,
                BillSponsorFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
                BillTitleFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
                BillReviewFilterGroup,
                FromTrackingBoardInvisibleFilterGroup,
                BillInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                BillOrderByFilterGroup,
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? [
                      // TODO: The below isGrassrootsPersona() filters haven't been reordered
                      // for ff_personas. TBD per Product team if there should be changes.
                      SupporterCampaignFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterTextFilterGroup,
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCustomEventFilterGroup,
                      SupporterDateFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterListFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  ]
                : [
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      SupporterListFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterDateFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterCampaignFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterOrderByFilterGroup,
                  ],
            PublicOrganizationFilterSet: [
                PublicOrganizationCustomFilterGroup,
                PublicOrganizationTypeFilterGroup,
                PublicOrganizationParentFilterGroup,
                ...(Userdata.Permissions.is_comms_only
                    ? [PublicOrganizationSocialMediaFilterGroup]
                    : [PublicOrganizationDocumentFilterGroup]),
                PublicOrganizationRegionFilterGroup,
                PublicOrganizationProjectFilterGroup,
                AssignmentFilterGroup,
                PublicOrganizationListFilterGroup,
                InvisibleDefaultFilterGroup,
                PublicOrganizationOrderByFilterGroup,
            ],
        },
        seeMoreFilterGroups: {
            OfficialFilterSet: [
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [OfficialPACTransactionsFilterGroup]
                    : []),
                PersonDocumentFilterGroup,
            ],
            BillFilterSet: [
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                    ? [BillDataMaintenanceFilterGroup]
                    : []),
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? []
                : [
                      SupporterTextFilterGroup,
                      SupporterCustomEventFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                      SupporterDataMaintenanceFilterGroup,
                  ],
            PublicOrganizationFilterSet: [
                PublicOrganizationOutletFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [PublicOrganizationPacFilterGroup]
                    : []),
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                    ? [PublicOrganizationDataMaintenanceFilterGroup]
                    : []),
            ],
        },
    },
    [DjangIO.app.userdata.types.UserPersona.stakeholder_relationship_manager.value]: {
        filterGroups: {
            OfficialFilterSet: [
                OfficialCustomFilterGroup,
                OfficialTypeFilterGroup,
                OfficialLegislativeRoleFilterGroup,
                OfficialExecutiveRoleFilterGroup,
                OfficialPartyFilterGroup,
                OfficialCommitteeFilterGroup,
                OfficialLegislativeActionsFilterGroup,
                OfficialAssumedOfficeFilterGroup,
                ...(Userdata.isOnlyEUMode() || Userdata.current_regions_values.every((r) => usRegions.includes(r))
                    ? [PersonRepresentsRegionFilterGroup]
                    : [PersonRepresentsInternationalRegionFilterGroup]),
                PersonRepresentingFilterGroup,
                PersonStakeholderFilterGroup,
                PersonProjectFilterGroup,
                PersonListFilterGroup,
                AssignmentFilterGroup,
                PersonInteractionFilterGroup,
                PersonOutboxFilterGroup,
                OfficialCampaignFilterGroup,
                OfficialsCampaignFinanceFilterGroup,
                OfficialCustomEventFilterGroup,
                OfficialBiographyFilterGroup,
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
                    ? [OfficialDataMaintenanceFilterGroup]
                    : []),
                InvisibleDefaultFilterGroup,
            ],
            BillFilterSet: [
                BillCustomFilterGroup,
                BillDateFilterGroup,
                ...(languageFilterEnabled ? [BillLanguageFilterGroup] : []),
                ...(Userdata.isGlobalMode() ? [] : [BillTypeFilterGroup]),
                BillStatusFilterGroup,
                BillSupportedRegionFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillSourceFilterGroup]),
                BillStanceFilterGroup,
                BillPriorityFilterGroup,
                BillProjectFilterGroup,
                BillListFilterGroup,
                AssignmentFilterGroup,
                BillTrackingDashboardFilterGroup,
                BillSponsorFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillCommitteeFilterGroup]),
                BillTitleFilterGroup,
                ...(Userdata.isGlobalMode() ? [] : [BillTermFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillCompanionFilterGroup]),
                ...(Userdata.isGlobalMode() ? [] : [BillRelatedFilterGroup]),
                BillReviewFilterGroup,
                FromTrackingBoardInvisibleFilterGroup,
                BillInvisibleFilterGroup,
                InvisibleDefaultFilterGroup,
                BillOrderByFilterGroup,
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? [
                      // TODO: The below isGrassrootsPersona() filters haven't been reordered
                      // for ff_personas. TBD per Product team if there should be changes.
                      SupporterCampaignFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterTextFilterGroup,
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCustomEventFilterGroup,
                      SupporterDateFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterListFilterGroup,
                      SupporterDataMaintenanceFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                  ]
                : [
                      SupporterCustomFilterGroup,
                      SupporterSearchFilterGroup,
                      SupporterOrganizationFilterGroup,
                      SupporterGeographyFilterGroup,
                      SupporterStakeholderFilterGroup,
                      SupporterProjectFilterGroup,
                      SupporterListFilterGroup,
                      SupporterAssignmentFilterGroup,
                      SupporterLegislatorsFilterGroup,
                      SupporterDateFilterGroup,
                      PersonInteractionFilterGroup,
                      SupporterOutboxFilterGroup,
                      SupporterCampaignFilterGroup,
                      InvisibleDefaultFilterGroup,
                      SupporterOrderByFilterGroup,
                      SupporterCampaignFinanceFilterGroup,
                  ],
            PublicOrganizationFilterSet: [
                PublicOrganizationCustomFilterGroup,
                PublicOrganizationTypeFilterGroup,
                PublicOrganizationParentFilterGroup,
                ...(Userdata.Permissions.is_comms_only
                    ? [PublicOrganizationSocialMediaFilterGroup]
                    : [PublicOrganizationDocumentFilterGroup]),
                PublicOrganizationRegionFilterGroup,
                PublicOrganizationProjectFilterGroup,
                AssignmentFilterGroup,
                PublicOrganizationListFilterGroup,
                InvisibleDefaultFilterGroup,
                PublicOrganizationOrderByFilterGroup,
            ],
        },
        seeMoreFilterGroups: {
            OfficialFilterSet: [
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [OfficialPACTransactionsFilterGroup]
                    : []),
                PersonDocumentFilterGroup,
            ],
            BillFilterSet: [
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.bill)
                    ? [BillDataMaintenanceFilterGroup]
                    : []),
            ],
            SupporterFilterSet: isGrassrootsPersona()
                ? []
                : [
                      SupporterTextFilterGroup,
                      SupporterCustomEventFilterGroup,
                      ...(isAnyFeatureEnabled("ff_pac", "ff_restricted_gr_pages") ? [SupporterPACFilterGroup] : []),
                      SupporterDataMaintenanceFilterGroup,
                  ],
            PublicOrganizationFilterSet: [
                PublicOrganizationOutletFilterGroup,
                ...(hasAnyPermission([DjangIO.app.models.PermissionType.qpac_v1])
                    ? [PublicOrganizationPacFilterGroup]
                    : []),
                ...(bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.public_organization)
                    ? [PublicOrganizationDataMaintenanceFilterGroup]
                    : []),
            ],
        },
    },
    [DjangIO.app.userdata.types.UserPersona.grassroots_nonprofit_director.value]: grassrootsFilterGroups,
    [DjangIO.app.userdata.types.UserPersona.grassroots_corp_director.value]: grassrootsFilterGroups,
    [DjangIO.app.userdata.types.UserPersona.grassroots_associate.value]: grassrootsFilterGroups,
    [DjangIO.app.userdata.types.UserPersona.pac_manager.value]: pacFilterGroups,
    [DjangIO.app.userdata.types.UserPersona.pac_treasurer.value]: pacFilterGroups,
}

export const PersonifiedFilterSet = (FilterSet) => {
    // Do not apply filter personification if
    // - User hasn't selected a persona yet
    // - Selected persona is not defined in UserPersonaConstant
    if (Userdata.user_persona && UserPersonaConstant[Userdata.user_persona]) {
        FilterSet.defaultProps = {
            filterGroups:
                UserPersonaConstant[Userdata.user_persona].filterGroups[FilterSet.defaultProps.name] ||
                FilterSet.defaultProps.filterGroups,
            name: FilterSet.defaultProps.name,
            seeMoreFilterGroups:
                UserPersonaConstant[Userdata.user_persona].seeMoreFilterGroups[FilterSet.defaultProps.name],
        }
    }
    return FilterSet
}
